import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  city: string;
  quote: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-lg border border-purple-100 my-8 max-w-2xl mx-auto transform hover:scale-[1.02] transition-transform duration-300" data-id="element-204">
      <div className="flex gap-1 mb-4 text-yellow-400" data-id="element-205">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} size={18} fill="currentColor" data-id="element-206" />)}
      </div>
      <p className="text-gray-700 italic text-lg mb-6 leading-relaxed font-serif" data-id="element-207">
        "{quote}"
      </p>
      <div className="flex items-center gap-3" data-id="element-208">
        <div className="w-10 h-10 rounded-full bg-purple-200 flex items-center justify-center text-purple-700 font-bold font-serif" data-id="element-209">
          {name.charAt(0)}
        </div>
        <div className="text-sm" data-id="element-210">
          <p className="font-bold text-gray-900" data-id="element-211">
            {name}, {age}
          </p>
          <p className="text-gray-500" data-id="element-212">{city}</p>
        </div>
      </div>
    </div>;
}